import axios from "axios";

const GETPATIENTS_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/admin/patients";

class ServicePatient {
  getPatientsByIdAdmin(adminId) {
    return axios.get(GETPATIENTS_API_BASE_URL + "/" + adminId);
  }
}

export default new ServicePatient();
